import { createLifecycleFor } from 'ext/lib/collections';

export const TYPE = 'user';

export const { resolve, reject } = createLifecycleFor(TYPE);
